// @ts-check
import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import FlashMessage from 'shared/components/FlashMessage';
import TopNav from './TopNav';
import SideNav from './SideNav';
import styles from './FuturePortalLayout.module.scss';
import FullLogoImageSrc from './TopNav/assets/aristamd_logo.svg';
// import CrossImageSrc from './TopNav/assets/preferral_cross.svg';
import StackedLogoImageSrc from './TopNav/assets/aristamd_stacked.svg';

class FuturePortalLayout extends Component {
  constructor(props, state) {
    super(props, state);
    this.state = { sideNavOpen: false };
    this.handleSideNavOpenToggle = this.handleSideNavOpenToggle.bind(this);
  }

  handleSideNavOpenToggle() {
    this.setState({ sideNavOpen: !this.state.sideNavOpen });
  }

  render() {
    const { sideNavOpen } = this.state;
    const { title, pendingReferralsCount, currentEmployment } = this.props;

    return (
      <div
        className={cx(styles.grid, 'proxima_nova', {
          [styles.has_sidebar_open]: sideNavOpen,
        })}
      >
        <FlashMessage />
        <div className={styles.left_logo_container}>
          <img
            alt="AristaMD Logo"
            src={sideNavOpen ? FullLogoImageSrc : StackedLogoImageSrc}
          />
        </div>
        <nav className={styles.nav_container}>
          <TopNav
            title={title}
            onHamburgerClick={this.handleSideNavOpenToggle}
          />
        </nav>
        <div className={styles.content_container}>{this.props.children}</div>
        <div className={styles.sidebar_container}>
          <SideNav
            isOpen={sideNavOpen}
            pendingReferralsCount={pendingReferralsCount}
            currentEmployment={currentEmployment}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentEmployment: state.currentAgent.currentEmployment,
    pendingReferralsCount: state.referrals.pendingReferralsCount,
  };
}

export default connect(mapStateToProps)(FuturePortalLayout);
